import { default as AnalyticEvents } from '@mitel-internal/cloudlink-analytic-events/analytic-events.json';
import { AnalyticAttributes } from '../interfaces/analytics-interfaces';
export const ContentTypes = {
  ATTACHMENT: 'application/vnd.mitel.attachment',
  LOCATION: 'application/vnd.mitel.location',
  QUOTED: 'application/vnd.mitel.quoted-message',
  HTML: 'text/html',
  TEXT: 'text/plain',
  ACTIONCARD: 'application/vnd.mitel.action-card',
  WHISPER: 'application/vnd.mitel.chat-whisper',
  //Not officially part of the Mitel message definitions, can remove when we switch to using tags for CO conversations
  HIDDEN: 'application/vnd.mitel.hidden',
  MISSEDCALL: 'application/vnd.mitel.missed-call',
  VOICEMAIL: 'application/vnd.mitel.voice-mail',
  SYSTEMMESSAGE: 'application/vnd.mitel.system-message',
  //Custom for Chat Component
  ATTACHMENTSYSTEMMESSAGE: 'application/vnd.mitel.attachment-system-message',
  MSADAPTIVECARD: 'application/vnd.microsoft.card.adaptive',
  ERROR: 'error',
  //aiMode assistant replies (markdown-it + highlight.js, sanitized via DOMPurify)
  MARKDOWN: 'text/markdown',
  //A file shared as a link from cloud storage - the body is a ChatCloudFileLink
  CLOUDFILELINK: 'application/vnd.mitel.cloud-file-link'
};

export const ActionCardActions = {
  POSTMESSAGE: 'post-message',
  POSTQUOTEDMESSAGE: 'post-quoted-message',
  REPLY: 'reply',
  SHARELOCATION: 'share-location',
  PHONE: 'phone',
  HTTPPOST: 'http-post',
  OPENLINK: 'open-link',
  RAISEEVENT: 'raise-event'
};

export const ActionCardBehaviorActions = {
  POSTMESSAGE: 'post-message',
  POSTREACTION: 'post-reaction'
};

export const ChatStorageKeys = {
  CHAT_INPUT: 'clComponentChatInputs'
};

export const ChatAnalyticAttributes: AnalyticAttributes = {
  AppFeature: AnalyticEvents.attributes.common.app_feature.chat,
  Location: AnalyticEvents.attributes.common.location.chat,
  LocationComponent: AnalyticEvents.attributes.web.location_component.web_uc_smb.chat
};

export const ChatMaxValues = {
  MaxImageSize: 2097152
};

export const MuteOptions = {
  ONE_HOUR: 'cl_chat.muteForHour',
  ONE_DAY: 'cl_chat.muteForDay',
  ALWAYS: 'cl_chat.always'
};

export const ChatMessageLimits = {
  MaxQuotedMessageReply: 764,
  MaxQuotedMessageCite: 47
};

export const GoogleMaps = {
  API_KEY: 'AIzaSyCPbbgogJOUj1RG2VHHSoDc9ax2xZOeipc',
  MAP_ID: 'b16caf57eea4179188785f94'
};
